import { Component, OnInit, Output, EventEmitter, Input, SimpleChange } from '@angular/core';

@Component({
  selector: 'spekwo-cost-option-dropdown',
  templateUrl: './cost-option-dropdown.component.html',
  styleUrls: ['./cost-option-dropdown.component.scss']
})
export class CostOptionDropdownComponent implements OnInit {

  @Output() onCostOptionChange = new EventEmitter<string>();
  @Input() initialValue:string;

  costOptions = [
    { value: 'manual', viewValue: 'Manual Entry' },
    { value: 'Flat', viewValue: 'Flat Rate' },
    { value: 'tm', viewValue: 'T&M' },
    { value: 'foot', viewValue: 'by the foot' },
  ];
  selectedCostOption: string = '';
   
  constructor() { }

  ngOnInit() {
    this.selectedCostOption=this.initialValue;
  }

  ngOnChanges(changes:SimpleChange){
    this.selectedCostOption=this.initialValue;
  }

  //Assigning costOption to form value
  costSelection() {
    this.onCostOptionChange.emit(this.selectedCostOption);
  }

}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/common/cost-option-dropdown/cost-option-dropdown.component.ts